import { cn } from '@/lib/utils';

const H3 = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default' | 'notItalic';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[24px] text-[24px] 2xl:text-[32px] abc-italic inline-block leading-[120%]',
        notItalic:
            'not-italic lg:text-[24px] text-[24px] 2xl:text-[32px] abc inline-block leading-[120%]',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <h3
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

H3.displayName = 'H3';

export default H3;
